var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('Spinner'):_c('div',_vm._l((_vm.allRoles),function(role){return _c('vca-column',{key:role.value,staticClass:"short"},[_c('h4',[_vm._v(_vm._s(role.name)+":")]),_c('span',[_vm._v(_vm._s(_vm.getAsps(role)))])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }